import { NgModule } from '@angular/core';
import { MsTabComponent } from './ms-tab.component';
import { SharedLibsModule } from 'app/shared/shared-libs.module';

@NgModule({
	declarations: [MsTabComponent],
	imports: [SharedLibsModule],
	exports: [MsTabComponent],
	providers: [],
})
export class MsTabModule {}
